import Vuetify from "vuetify";

const DEFAULT_THEME = {
    primary: "#00494E",
    secondary: "#9EB38D",
    accent: "#00494E",
    lilac: "#D5CFEB",
    error: "#FF4141"
};

export function buildTheme(style) {
    if (!style) return DEFAULT_THEME;

    return {
        ...DEFAULT_THEME,
        primary: style.primary,
        accent: style.primary,
        secondary: style.accent,
    };
}

export default {
    install(Vue, theme) {
        Vue.use(Vuetify, {
            iconfont: "mdi",
            theme: theme || DEFAULT_THEME,
        });
    }
};
